import type { RecruitAction } from "../types/actions";
import type { WarchestState } from "../types/game-state";
import {
  advanceActivePlayer,
  allHandsEmpty,
  moveCoin,
} from "../utils/zone-utils";

export function applyRecruit(
  state: WarchestState,
  action: RecruitAction,
): WarchestState {
  let zones = moveCoin(
    state.playerZones[action.player],
    action.coinType,
    "hand",
    "discardFaceUp",
  );
  zones = moveCoin(zones, action.recruitCoinType, "supply", "discardFaceUp");
  const newPlayerZones = { ...state.playerZones, [action.player]: zones };
  const nextActive = advanceActivePlayer(action.player, newPlayerZones);
  const nextPhase = allHandsEmpty(newPlayerZones)
    ? ("DRAW_COINS" as const)
    : state.phase;
  return {
    ...state,
    playerZones: newPlayerZones,
    activePlayer: nextActive,
    phase: nextPhase,
    initiativeTransferredThisRound:
      nextPhase === "DRAW_COINS" ? false : state.initiativeTransferredThisRound,
    turn: nextPhase === "DRAW_COINS" ? state.turn + 1 : state.turn,
  };
}
